import useAxiosRequest from "../hooks/useAxiosRequest";
import {createContext, useEffect, useState} from "react";
import OverlayDiv from "../components/OverlayDiv";
import _ from 'lodash';

import '../styles/MapEditor.css';
import LegendItemElement from "../components/LegendItemElement";
import DivisionTypeElement from "../components/DivisionTypeElement";
import axios from "axios";
import Button from "../components/Button";

import config from '../config.json';

export const MapContext = createContext(null);
export const SelectedContext = createContext(null);

const SidebarItem = ({ children }) => {
    return <div className="sidebar-item">{children}</div>
}

const MapEditor = ({ id }) => {
    let { data: map, setData: setMap } = useAxiosRequest({
        url: `${config.backendUrl}/maps/${id}`,
        withCredentials: true,
        method: "get"
    });

    let { isLoading, error, data: template } = useAxiosRequest({
        url: `${config.backendUrl}/maps/templates/${map?.template}`,
        withCredentials: true,
        method: "get"
    }, [ map ]);

    const [ selectedLegendItem, setSelectedLegendItem ] = useState(null);

    useEffect(() => {
        if (!map || !template) return;

        Object.entries(map.divisions).forEach(([ division, legendItemId ]) => {
            const legendItem = template.legend.find(item => item.id === legendItemId);

            document.querySelectorAll(`path.division-${division}`).forEach(element => element.style.fill = legendItem.color);
        });
    }, [map, template]);

    if (isLoading || error) return;

    return (
        <MapContext.Provider value={{ map, template, setMap }}>
            <SelectedContext.Provider value={{ selectedLegendItem, setSelectedLegendItem }}>
                <div id="MapEditor">
                    <div id="sidebarL" className="sidebar">
                        <Button content='Back' color='blue' onClick={() => window.location = '/maps'}/>
                        <SidebarItem>
                            <span style={{ fontWeight: 700, margin: "auto 0" }}>Divisions</span>
                        </SidebarItem>
                        {template.division_types.map(divisionType => <DivisionTypeElement key={divisionType.id} id={divisionType.id}/>)}
                    </div>
                    <div id="main-content">
                        <OverlayDiv>
                            <div id="image-container" dangerouslySetInnerHTML={{__html: atob(template.image)}}
                                 onClick={e => {
                                     if (!selectedLegendItem) return;

                                     const elements = document.elementsFromPoint(e.nativeEvent.clientX, e.nativeEvent.clientY);

                                     if (elements[0]?.tagName !== 'path') return;

                                     const element = elements[0];

                                     const classes = element.className.baseVal.split(' ');

                                     const division = classes.find(x => x.startsWith('division-'))?.split('-')[1];

                                     const modifiedMap = _.cloneDeep(map);

                                     modifiedMap.divisions[division] = selectedLegendItem;

                                     axios({
                                         url: `${config.backendUrl}/maps/${map._id}`,
                                         withCredentials: true,
                                         method: "put",
                                         data: modifiedMap
                                     })
                                         .then(response => setMap(response.data))
                                         .catch(error => alert(error.toString()));
                                 }}>
                            </div>
                        </OverlayDiv>
                    </div>
                    <div id="sidebarR" className="sidebar" onClick={() => setSelectedLegendItem(null)}>
                        <div style={{ margin: '0 auto 20px auto' }}>
                            <Button content='Download' color='blue' onClick={() => {
                                axios({
                                    url: `${config.backendUrl}/maps/render/${map._id}`,
                                    withCredentials: true,
                                    responseType: 'blob',
                                    method: 'get'
                                })
                                    .then(response => {
                                        const href = URL.createObjectURL(response.data);

                                        const downloader = document.createElement('a');
                                        downloader.href = href;
                                        downloader.download = `${map.name}.png`;
                                        downloader.click();
                                    })
                                    .catch(error => alert(error.toString()));
                            }}/>
                        </div>
                        <SidebarItem>
                            <span style={{ fontWeight: 700, margin: "auto 0" }}>Legend</span>
                        </SidebarItem>
                        {template.legend.map(item => <LegendItemElement key={item.id} item={item}/>)}
                    </div>
                </div>
            </SelectedContext.Provider>
        </MapContext.Provider>
    )
}

export default MapEditor;
